import {UntypedFormControl, Validators} from "@angular/forms";
import {Patterns} from "../shared/enums/patterns";

/**
 * Common base class for create and update CPE components
 */
export abstract class CpeBase {
    
    readonly CPENAME_MIN_LENGTH = 1;
    readonly CPENAME_MAX_LENGTH = 64;

    roles = new UntypedFormControl([], [Validators.required]);
    cpeName = new UntypedFormControl('', [
        Validators.minLength(this.CPENAME_MIN_LENGTH), Validators.maxLength(this.CPENAME_MAX_LENGTH),
        Validators.pattern(Patterns.ALPHANUMERIC_DASH_UNDERSCORE)
    ]);
    
    header: string;
    title: string;
    loading: boolean = false;
    fieldcheck:boolean = false;
    count: number = 1;

    readonly CPENAME = 'CPENAME';

    constructor () { }
    
    getErrorMessage(formControl) {
        if (formControl === this.CPENAME) {
            if (this.cpeName.hasError('required')) {
                return 'You must enter a CPE name';
            }
            if (this.cpeName.hasError('minlength')) {
                return `CPE name must be at least ${this.CPENAME_MIN_LENGTH} character(s)`;
            }
            if (this.cpeName.hasError('maxlength')) {
                return `CPE name cannot exceed ${this.CPENAME_MAX_LENGTH} characters`;
            }
            if (this.cpeName.hasError('pattern')) {
                return 'CPE name can only contain alphanumeric characters, dashes, and underscores';
            }
            return '';
        } else {
            return '';
        }
    }

    change(event) {
        if(event) {
            if (event.srcElement.value !== '') {
                this.count = this.count + 1;
            } else if (event.srcElement.value === '') {
                this.count = this.count - 1;
            }
        }
        if (this.count <= 1 || this.fieldcheck === false) {
            this.fieldcheck = !this.fieldcheck;
        }
    }

    markFormControlsAsTouched() {
        this.cpeName.markAsTouched();
    }
}
